import {ChangeEvent, PropsWithChildren} from 'react';
import Image from 'next/image';

import PlusIcon from '../Icons/Plus';
import TrashIcon from '../Icons/Trash';

import {cn} from '@/lib/utils';
import {buttonVariants} from '../Button';

type Props = PropsWithChildren & {
  files: File[];
  className?: string;
  onChange: (file: File) => void;
  removeFile: (file: File) => void;
};

export default function ImageSelector({
  files,
  onChange,
  removeFile,
  className,
  children,
}: Props) {
  function handleOnChange(event: ChangeEvent<HTMLInputElement>) {
    const fileList = event.target.files;
    if (fileList) {
      const file = fileList[0];
      onChange(file);
    }
  }

  return (
    <div className="w-full">
      <input
        onChange={handleOnChange}
        id="file-input"
        type="file"
        className="hidden"
      />
      <label
        htmlFor="file-input"
        className={cn(
          buttonVariants({variant: 'outline', size: 'default'}),
          'md:w-[calc(50%-1rem)] xl:w-[calc(33%-1rem)]',
          className,
        )}>
        <PlusIcon className="w-8 h-8 mr-2 fill-current text-primary group-hover:text-white transition ease-in-out duration-200" />
        {children}
      </label>
      <div className="w-full flex flex-wrap">
        {files.map((image, index) => {
          const src = URL.createObjectURL(image);
          return (
            <div
              key={index}
              className="group max-w-[150px] max-h-[120px] relative flex items-center justify-center">
              <div className="relative w-full h-full min-w-[130px] max-h-[100px] min-h-[100px] mt-[16px] mr-[10px] inline-block align-middle max-w-[100%] group-hover:brightness-[0.8]">
                <Image
                  src={src}
                  alt="image to upload"
                  fill
                  sizes="(min-width: 1280px) 80vw, (min-width: 767px) 90vw, (min-width: 480px) 100vw, 100vw"
                />
              </div>
              <button
                onClick={() => removeFile(image)}
                className="hidden w-fit h-fit absolute group-hover:block appearance-none bg-transparent outline-none">
                <TrashIcon className="fill-current text-white w-12 h-[3rem] cursor-pointer align-middle z-50" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
